<template>
  <PageHeader :title="title" :breadcrumb="breadcrumb">
    <template #actions>
      <slot></slot>
    </template>
  </PageHeader>
</template>

<script setup>
const props = defineProps({
  icon: String,
  title: String,
  breadcrumb: {
    type: Boolean,
    default: false,
  },
})
</script>
